/** Central site configuration — single source of truth for production URLs */
export const SITE_URL = "https://qbdgroup.com";
export const SITE_NAME = "QbD Group";
export const DEFAULT_OG_IMAGE = `${SITE_URL}/og-image.png`;
